// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import {
//   LayoutDashboard,
//   Users,
//   FolderOpen,
//   TreePine,
//   CreditCard,
//   Map,
//   LogOut,
//   ChevronLeft,
//   ChevronRight,
// } from "lucide-react";
// import Logo2 from "../images/sikalogo.png";
// import { ROLE_PERMISSIONS } from "../utils/permissions";
// import "./Sidebar.css";

//  const navItems = [
//    { key: "map", name: "GIS Portal", href: "/map", icon: Map },
//    { key: "dashboard", name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
//    { key: "user", name: "User", href: "/user", icon: Users },
//    { key: "projects", name: "Projects", href: "/projects", icon: FolderOpen },
//    { key: "tree-species", name: "Tree Species", href: "/tree-species", icon: TreePine },
//    { key: "subscription", name: "Subscription", href: "/subscription", icon: CreditCard },
//  ];

// const Sidebar = ({ user, onLogout }) => {
//   const location = useLocation();
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   return (
//     <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
//       {/* Logo  Toggle */}
//       <div className="sidebar-logo">
//         {!isCollapsed && <img src={Logo2} alt="Logo" />}
//         <button
//           className="collapse-btn"
//           onClick={() => setIsCollapsed(!isCollapsed)}
//         >
//           {isCollapsed ? <ChevronRight size={40} /> : <ChevronLeft size={40} />}
//         </button>
//       </div>

//       {/* Navigation */}
//       <nav>
//         <ul>
//            {navItems
//             .filter(item => ROLE_PERMISSIONS[user?.role]?.includes(item.key))
//               .map((item) => {
//                 const isActive = location.pathname === item.href;
//                 return (
//                   <li key={item.key}>
//                     <Link to={item.href} className={isActive ? "active" : ""}>
//                       <item.icon className="nav-icon" size={18} />
//                       {!isCollapsed && <span>{item.name}</span>}
//                     </Link>
//                   </li>
//                 );
//               })}
//         </ul>
//       </nav>

//       {/* User  Logout */}
//       <div className="sidebar-user">
//         {!isCollapsed && <p>{user?.profile?.full_name || user?.email}</p>}
//         <button onClick={onLogout}>
//           <LogOut size={16} />
//           {!isCollapsed && <span>Logout</span>}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  FolderOpen,
  TreePine,
  CreditCard,
  Map,
  LogOut,
  ChevronLeft,
  ChevronRight,
  FileText,
} from "lucide-react";
import Logo2 from "../images/sikalogo.png";
import { ROLE_PERMISSIONS } from "../utils/permissions";
import "./Sidebar.css";

const navItems = [
  { key: "map", name: "GIS Portal", href: "/map", icon: Map },
  { key: "dashboard", name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
  { key: "user", name: "User", href: "/user", icon: Users },
  { key: "projects", name: "Projects", href: "/projects", icon: FolderOpen },
  { key: "tree-species", name: "Tree Species", href: "/tree-species", icon: TreePine },
  { key: "subscription", name: "Subscription", href: "/subscription", icon: CreditCard },
  { key: "tree-survey", name: "Tree Survey", href: "/tree-survey", icon: TreePine },
  // { key: "report", name: "Report", href: "/report", icon: FileText },
];

const Sidebar = ({ user, onLogout }) => {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* Logo & Toggle */}
      <div className="sidebar-logo">
        {!isCollapsed && <img src={Logo2} alt="Logo" />}
        <button
          className="collapse-btn"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {isCollapsed ? <ChevronRight size={40} /> : <ChevronLeft size={40} />}
        </button>
      </div>

      {/* Navigation */}
      <nav>
        <ul>
          {navItems
            .filter(item => ROLE_PERMISSIONS[user?.role]?.includes(item.key))
            .map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <li key={item.key}>
                  <Link to={item.href} className={isActive ? "active" : ""}>
                    <item.icon className="nav-icon" size={18} />
                    {!isCollapsed && <span>{item.name}</span>}
                  </Link>
                </li>
              );
            })}
        </ul>
      </nav>

      {/* User & Logout */}
      <div className="sidebar-user">
        {!isCollapsed && <p>{user?.profile?.full_name || user?.email}</p>}
        <button onClick={onLogout}>
          <LogOut size={16} />
          {!isCollapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;